const zh = {
  updateSuccess: '更新成功',
  updateFailed: '更新失败',
  delOrgSuccess: '删除组织成功,为您切换下一个组织。',
  delOrgFailed: '删除组织失败',
  addSuccess: '添加成功',
  addFailed: '添加失败',
  authSetSuccess: '权限设置成功，请刷新页面查看。',
  authSetFailed: '权限设置失败',
  disblMemSuccess: '禁用成员成功',
  disblMemFailed: '禁用成员失败',
  viewOrgRepo: '组织仓库查看',
  fullPermissions: '全部权限',
  editOrgDetails: '组织详情修改',
  manageSubOrgs: '下级组织管理',
  manageOrgMems: '组织成员管理',
  manageOrgDetailsMems: '组织详情以及成员管理',
  orgRepoInbound: '组织仓库(入库)',
  orgRepoOut: '组织仓库(出库)',
  manageSubOrgRepos: '下级组织仓库管理(出入库)',
  manageSubOrgAndMeb:'下级组织以及成员管理',
  mobileNumber: '手机号码',
  purview: '所属权限',
  avatar: '头像',
  phNumber: '手机号',
  setPermissions: '权限设置',
  disable: '停用',
  enable: '启用',
  thisMember:'该成员吗',
  delOrgTip1: '确定删除该组织吗？',
  delOrgTip2: '删除该组织后组织信息无法恢复，并且该组织下的用户也会移除，是否确认删除？',
  createNewMem: '创建新成员',
  selPerson: '请选择人员',
  orgInfo: '组织详情',
  addOrg: '添加组织',
  addSubOrgBut: '添加下级组织',
  members: '成员',
  noMem: '暂无成员',
  name: '名称',
  orgNameRequired: '组织名称不能为空!',
  desc: '描述',
  cancel: '取消',
  memList: '成员列表',
  addOrgMem: '添加组织成员',
  selMem: '请选择成员',
  setMemPurview: '设置成员({{userName}})权限',
  memDetails: '成员详情',
  prompt: '提示',
  conAction: '您确定要',
  enterName: '请输入名称',
  enterDesc: '请输入描述',
  managOrgUser: '系统管理/system manager,manager org|user',
  editOrgBasicInfo: '组织基本信息修改',
  manageOrgUsers: '组织user管理',
  manageOrgProfile: '组织profile管理',
  inboundManag: '入库管理',
  outboundManag: '出库管理',
  manageSubInv: '下级库存管理',
  unPurview:'未知权限',
  plEnterOrgName: "请输入组织名称",
  addOrgStru: "添加组织机构",
  noMove: "禁止同层级移动",
  addSubOrg: "添加({{name}})的下级组织",
  noData: "暂无数据",
  delOrgTip3: "该组织存在下级组织，请先删除下级组织再删除。",
  orgMoveSuc: "组织移动成功",
  orgMoveFail: "组织移动失败",
  selectAll: "全选",
  userNoOrg: "用户无参与组织，将在5秒后退出登录。",
  cancelTip: "当前已选择人员，确认取消吗？",
  delOrg: "删除组织",
  plEnterUserName: "请输入Name1、Name2、手机号进行搜索",
  noOrgData: "暂无找到该组织数据/组织可能被删除",
  orgFetchFail: '获取组织信息失败',
  orgListEmpty: "当前暂无组织，请先添加组织。",
  selectOrg: "请先选择组织",
  orgDisabled: "组织已被禁用或不存在",
  modifyOrgInfo: "修改组织信息",
  addOrDisableOrgMember: "添加/禁用组织成员",
  orgMemberPermissions: "设置组织成员权限",
};

export default zh;